module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loginAs":"Choose company to view for","currentlyLoggedInAs":"currently logged in"}}')
  delete Component.options._Ctor
}
